import { Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { getZahlweiseFromText } from '@ps20-frontend/migrations';
import { StatePreV4, StateV4 } from './4_migrate_zahlungsoptionen.interface';

export const migrateZahlungsoptionen = (previousState: StatePreV4, newVersion: number): StateV4 => {
  return {
    ...previousState,
    version: newVersion,
    zahlungsoptionen: {
      zahlungsweise: previousState.zahlungsoptionen?.zahlungsweise
        ? getZahlweiseFromText(previousState.zahlungsoptionen.zahlungsweise)
        : Zahlweise.MONATLICH,
      zahlungsart: previousState.zahlungsoptionen?.zahlungsart
        ? (Zahlungsart as Record<string, Zahlungsart>)[previousState.zahlungsoptionen.zahlungsart.toUpperCase()]
        : undefined,
    },
  };
};
